var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.86,29.46L16.94,1.66c-0.1-0.27-0.31-0.49-0.58-0.59c-0.05-0.02-0.11-0.04-0.17-0.05   C16.13,1.01,16.07,1,16,1s-0.13,0.01-0.19,0.02c-0.06,0.01-0.12,0.03-0.17,0.05c-0.25,0.1-0.46,0.3-0.57,0.56l-0.01,0.03   L4.07,29.63C3.92,30,4.01,30.42,4.29,30.7C4.48,30.9,4.74,31,5,31c0.12,0,0.24-0.02,0.36-0.07L16,26.87l10.64,4.06   C26.76,30.98,26.88,31,27,31c0.01,0,0.01,0,0.02,0c0.55,0,1-0.45,1-1C28.02,29.8,27.96,29.62,27.86,29.46z",
    fill: "#2197F3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.02,30c0,0.55-0.45,1-1,1c-0.01,0-0.01,0-0.02,0c-0.12,0-0.24-0.02-0.36-0.07L16,26.87V1    c0.07,0,0.13,0.01,0.19,0.02c0.06,0.01,0.12,0.03,0.17,0.05c0.27,0.1,0.48,0.32,0.58,0.59l10.92,27.8    C27.96,29.62,28.02,29.8,28.02,30z",
    fill: "#16BCD4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_11_"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_10_"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_9_"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_8_"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_7_"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_6_"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_5_"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_4_"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_3_"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_2_"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Maps_1_"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Maps"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.5320f4ef0737ab5351a45bc632c26888.svg";
export { ForwardRef as ReactComponent };